import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

/**
 * Provides an abstract wrapper around showing a MatSnackbar
 * notification based on global environment or API provided
 * configuration.
 *
 * This class Listens for the authentication state to change.
 * Once the state becomes authenticated, retrieve the startup
 * configuration from the API service. Once de-authenticated
 * set the _params to undefined and unsubscribe.
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  /**
   * Constructor
   * @param toast  Toaster
   */
  constructor(private toastr: ToastrService, private translate: TranslateService) {}

  show(message: string) {
    return this.toastr.success(message);
  }
  success(message: string) {
    return this.toastr.success(message, this.translate.instant('notification.success'));
  }
  error(message: string) {
    return this.toastr.error(message, this.translate.instant('notification.error'));
  }
  warning(message: string) {
    return this.toastr.warning(message, this.translate.instant('notification.warning'));
  }
  info(message: string) {
    return this.toastr.info(message, this.translate.instant('notification.info_header'));
  }
}
